import React from "react";
import { Link } from "react-router-dom";
import { Building2, Coins, HandHeart, ArrowRight, Briefcase, Calendar, Users } from "lucide-react";
import { PageHero, Section, Card } from "@/components/Section";
import { IMAGES } from "@/lib/site";

const espaces = [
  {
    icon: Building2,
    titre: "Bureau des entreprises",
    description: "Le point de contact unique pour piloter les stages, PFMP, interventions et partenariats durables.",
    to: "/entreprises/bureau",
    accent: "bg-brand-slate text-brand-cream",
    testid: "espace-bureau",
  },
  {
    icon: Coins,
    titre: "Taxe d'apprentissage",
    description: "Soutenez nos formations professionnelles en affectant votre solde via SOLTÉA.",
    to: "/entreprises/taxe-apprentissage",
    accent: "bg-brand-sand-dark text-white",
    testid: "espace-taxe",
  },
  {
    icon: HandHeart,
    titre: "Devenir partenaire",
    description: "Rejoignez notre réseau d'entreprises engagées pour la réussite des jeunes.",
    to: "/entreprises/devenir-partenaire",
    accent: "bg-brand-sage-dark text-white",
    testid: "espace-devenir",
  },
];

const chiffres = [
  { icon: Briefcase, v: "40+", l: "entreprises partenaires" },
  { icon: Users, v: "350+", l: "élèves en stage / an" },
  { icon: Calendar, v: "12", l: "événements entreprises / an" },
];

export default function EspaceEntreprises() {
  return (
    <div data-testid="espace-entreprises-hub">
      <PageHero
        eyebrow="Espace entreprises"
        title="Construire ensemble la réussite professionnelle des jeunes"
        subtitle="Le lycée Joseph Wresinski entretient des liens étroits avec le tissu économique angevin. Notre Espace entreprises rassemble tous les outils pour collaborer avec nous, financer nos formations et accueillir nos futurs talents."
        image={IMAGES.partenaires}
      />

      <Section>
        <div className="grid gap-6 md:grid-cols-3">
          {espaces.map((e) => (
            <Link
              key={e.to}
              to={e.to}
              data-testid={e.testid}
              className="group flex flex-col rounded-3xl border border-black/5 bg-brand-cream p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <span className={`grid h-14 w-14 place-items-center rounded-2xl ${e.accent}`}>
                <e.icon className="h-6 w-6" />
              </span>
              <h2 className="mt-6 font-heading text-2xl font-bold text-brand-slate-dark">
                {e.titre}
              </h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{e.description}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brand-slate-dark transition-colors group-hover:text-brand-sand-dark">
                Accéder
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </Section>

      <Section wrapper="bg-brand-sand-wrapper/40">
        <div className="grid gap-6 sm:grid-cols-3">
          {chiffres.map((c) => (
            <Card key={c.l} className="text-center">
              <c.icon className="mx-auto h-7 w-7 text-brand-sage-dark" />
              <p className="mt-4 font-heading text-4xl font-bold text-brand-slate-dark">{c.v}</p>
              <p className="mt-1 text-sm text-muted-foreground">{c.l}</p>
            </Card>
          ))}
        </div>
      </Section>
    </div>
  );
}
